import { memo, FC } from 'react'
import { Flex } from '@chakra-ui/react'

import usePagination from './hooks/usePagination'
import LimitSelect from './components/LimitSelect'
import PageItems from './components/PageItems'
import PageShortCut from './components/PageShortCut'

type Props = {
  currentPage?: number
  limit?: number
  totalItems: number
  onChangePage: (newPage: number) => void
  onChangeLimit?: (newLimit: number) => void
}

const Pagination: FC<Props> = ({ currentPage = 1, limit = 15, totalItems, onChangePage, onChangeLimit }) => {
  const { choosePages } = usePagination({
    currentPage: Number(currentPage),
    limit: Number(limit),
    totalItems,
  })

  if (totalItems < limit) {
    return <></>
  }

  return (
    <Flex mt={2} align="center" justify="center" flexWrap="wrap" gap={2}>
      <PageItems currentPage={currentPage} choosePages={choosePages} onChangePage={onChangePage} />
      {onChangeLimit && (
        <LimitSelect
          limit={limit}
          onChangeLimit={(newLimit: number) => {
            onChangeLimit(newLimit)
            onChangePage(1)
          }}
        />
      )}
      <PageShortCut totalItems={totalItems} limit={limit} onChangePage={onChangePage} />
    </Flex>
  )
}

export default memo(Pagination)
